/**
 * Directions and Positions Vocabulary
 * 方向和位置相关单词
 */

import { VocabularyWord } from './vocabulary';

export const directionsVocabulary: VocabularyWord[] = [
  // 基本方向 - 小学4-5年级
  {
    id: 'left',
    word: 'left',
    phonetic: '/left/',
    phoneticUS: '/left/',
    phoneticUK: '/left/',
    meaning: '左边；向左',
    example: 'Turn left at the corner.',
    exampleTranslation: '在拐角处向左转。',
    category: 'directions',
    difficulty: 'easy',
    grade: '4',
    level: 'elementary',
    image: '⬅️'
  },
  {
    id: 'right-direction',
    word: 'right',
    phonetic: '/raɪt/',
    phoneticUS: '/raɪt/',
    phoneticUK: '/raɪt/',
    meaning: '右边；向右',
    example: 'Turn right at the traffic light.',
    exampleTranslation: '在红绿灯处向右转。',
    category: 'directions',
    difficulty: 'easy',
    grade: '4',
    level: 'elementary',
    image: '➡️'
  },
  {
    id: 'up',
    word: 'up',
    phonetic: '/ʌp/',
    phoneticUS: '/ʌp/',
    phoneticUK: '/ʌp/',
    meaning: '向上；在上面',
    example: 'Look up at the sky.',
    exampleTranslation: '抬头看天空。',
    category: 'directions',
    difficulty: 'easy',
    grade: '3',
    level: 'elementary',
    image: '⬆️'
  },
  {
    id: 'down',
    word: 'down',
    phonetic: '/daʊn/',
    phoneticUS: '/daʊn/',
    phoneticUK: '/daʊn/',
    meaning: '向下；在下面',
    example: 'Sit down, please.',
    exampleTranslation: '请坐下。',
    category: 'directions',
    difficulty: 'easy',
    grade: '3',
    level: 'elementary',
    image: '⬇️'
  },
  {
    id: 'north',
    word: 'north',
    phonetic: '/nɔrθ/',
    phoneticUS: '/nɔrθ/',
    phoneticUK: '/nɔːθ/',
    meaning: '北方',
    example: 'Beijing is in the north.',
    exampleTranslation: '北京在北方。',
    category: 'directions',
    difficulty: 'medium',
    grade: '5',
    level: 'elementary',
    image: '🧭'
  },
  {
    id: 'south',
    word: 'south',
    phonetic: '/saʊθ/',
    phoneticUS: '/saʊθ/',
    phoneticUK: '/saʊθ/',
    meaning: '南方',
    example: 'Guangzhou is in the south.',
    exampleTranslation: '广州在南方。',
    category: 'directions',
    difficulty: 'medium',
    grade: '5',
    level: 'elementary',
    image: '🧭'
  },
  {
    id: 'east',
    word: 'east',
    phonetic: '/iːst/',
    phoneticUS: '/iːst/',
    phoneticUK: '/iːst/',
    meaning: '东方',
    example: 'The sun rises in the east.',
    exampleTranslation: '太阳从东方升起。',
    category: 'directions',
    difficulty: 'medium',
    grade: '5',
    level: 'elementary',
    image: '🌅'
  },
  {
    id: 'west',
    word: 'west',
    phonetic: '/west/',
    phoneticUS: '/west/',
    phoneticUK: '/west/',
    meaning: '西方',
    example: 'The sun sets in the west.',
    exampleTranslation: '太阳在西方落下。',
    category: 'directions',
    difficulty: 'medium',
    grade: '5',
    level: 'elementary',
    image: '🌇'
  },
  {
    id: 'front',
    word: 'front',
    phonetic: '/frʌnt/',
    phoneticUS: '/frʌnt/',
    phoneticUK: '/frʌnt/',
    meaning: '前面；正面',
    example: 'Please stand in front.',
    exampleTranslation: '请站在前面。',
    category: 'directions',
    difficulty: 'easy',
    grade: '4',
    level: 'elementary',
    image: '👆'
  },
  {
    id: 'back',
    word: 'back',
    phonetic: '/bæk/',
    phoneticUS: '/bæk/',
    phoneticUK: '/bæk/',
    meaning: '后面；背面',
    example: 'Please go to the back.',
    exampleTranslation: '请到后面去。',
    category: 'directions',
    difficulty: 'easy',
    grade: '4',
    level: 'elementary',
    image: '👇'
  },
  {
    id: 'between',
    word: 'between',
    phonetic: '/bɪˈtwiːn/',
    phoneticUS: '/bɪˈtwiːn/',
    phoneticUK: '/bɪˈtwiːn/',
    meaning: '在...之间',
    example: 'The shop is between the bank and school.',
    exampleTranslation: '商店在银行和学校之间。',
    category: 'directions',
    difficulty: 'medium',
    grade: '5',
    level: 'elementary',
    image: '↔️'
  },
  {
    id: 'next-to',
    word: 'next to',
    phonetic: '/nekst tuː/',
    phoneticUS: '/nekst tuː/',
    phoneticUK: '/nekst tuː/',
    meaning: '紧挨着；在...旁边',
    example: 'My house is next to the park.',
    exampleTranslation: '我家紧挨着公园。',
    category: 'directions',
    difficulty: 'medium',
    grade: '5',
    level: 'elementary',
    image: '🏘️'
  },
  {
    id: 'across',
    word: 'across',
    phonetic: '/əˈkrɔs/',
    phoneticUS: '/əˈkrɔs/',
    phoneticUK: '/əˈkrɒs/',
    meaning: '穿过；在对面',
    example: 'The bank is across the street.',
    exampleTranslation: '银行在街对面。',
    category: 'directions',
    difficulty: 'medium',
    grade: '6',
    level: 'elementary',
    image: '🚶'
  },
  {
    id: 'opposite',
    word: 'opposite',
    phonetic: '/ˈɑpəzɪt/',
    phoneticUS: '/ˈɑpəzɪt/',
    phoneticUK: '/ˈɒpəzɪt/',
    meaning: '对面的；相反的',
    example: 'The school is opposite the park.',
    exampleTranslation: '学校在公园对面。',
    category: 'directions',
    difficulty: 'medium',
    grade: '6',
    level: 'elementary',
    image: '🔄'
  },
];

export default directionsVocabulary;
